// types
import { ReviewedCart } from "@cart-client/interfaces/Cart";
import { PlanDetails } from "@swiggy-private/cart-types";

// utils
import { getNestedValue, isEmpty } from "@swiggy-private/js-utils";

// constants
import { ProgramSubTypes, ProgramTypes } from "@swiggy-private/super-ui";

export const isBlackMembershipPlan = (cartResponse: ReviewedCart | null) => {
    if (!isEmpty(cartResponse)) {
        const activePlanDetails = getNestedValue(
            cartResponse,
            "data.swiggyOneInfo.presentationInfo.active_plan_details",
            {} as PlanDetails,
        );

        if (activePlanDetails?.program === ProgramTypes.ONE && activePlanDetails?.type === ProgramSubTypes.BLACK) {
            return true;
        }
    }

    return false;
};
